<template>
  <div class="app-container">
    <div v-if="user">
      <el-row :gutter="20">
        <el-col :span="6" :xs="24">
          <user-card :user="user" />
        </el-col>

        <el-col :span="18" :xs="24">
          <el-card>
            <el-tabs v-model="activeTab">
              <!-- <el-tab-pane label="Activity" name="activity">
                <activity />
              </el-tab-pane>
              <el-tab-pane label="Timeline" name="timeline">
                <timeline />
              </el-tab-pane> -->
              <el-tab-pane label="帳號相關" name="account">
                <account :user="formUser" />
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserCard from './components/UserCard'
import Activity from './components/Activity'
import Timeline from './components/Timeline'
import Account from './components/Account'

export default {
  name: 'ItaProfile',
  components: { UserCard, Activity, Timeline, Account },
  data() {
    return {
      user: {},
      activeTab: 'account',
      formUser: {},
    }
  },
  computed: {
    ...mapGetters(['account', 'name', 'avatar', 'roles', 'userInfo']),
  },
  created() {
    this.getUser()
  },
  methods: {
    getUser() {
      this.user = {
        id: this.userInfo.userID,
        account: this.account,
        name: this.name,
        role: this.roles,
        email: 'admin@test.com',
        avatar: this.avatar,
      }
      this.formUser = JSON.parse(JSON.stringify(this.user))
    },
  },
}
</script>

<style scoped>
.el-tab-pane {
  height: auto !important;
  /* overflow-y: auto; */
}
</style>
